let addSum = (total, num) => {
  return total + num;
};

let addNumbers = (arrayOfNumbers) => {
  if (arrayOfNumbers.length <= 0) {
    return 0;
  }
  let result = arrayOfNumbers.reduce(addSum);
  return result;
};

let convertToMinutes = (day, hour, minutes) => {
  let noOfMinutes = day * 1440 + hour * 60 + minutes;
  return noOfMinutes;
};

export default { addNumbers: addNumbers, convertToMinutes: convertToMinutes };
